import { get } from 'lodash'

export const getCurrentUserEmail = state => get(state, 'appState.user.email', 'unknown')

export const getCurrentUserOffset = state => state?.appState?.offset ?? 'unknown'

export const getScreenScrollOffset = (state, screen) => state?.appState?.screenScrollOffset?.[screen] ?? 0

export const getCurrentPaginationPage = (state, screen) => state?.appState?.screenPaginationPage?.[screen]?.page ?? 0
